import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material'
import React, { useMemo, useState } from 'react'
import { ChevronRight } from '@mui/icons-material'
import { FormattedMessage, useIntl } from 'react-intl'
import RightDrawer from '../../../../../components/RightDrawer'
import Icon from '@mdi/react'
import { mdiFastForward } from '@mdi/js'
import ButtonLink from '../../../../../components/ButtonLink'
import InfoField from '../../../../../components/InfoField'
import BankActionFormPopin from './BankActionFormPopin'
import { estMajeurFinAnnee } from '../../../../../utils/dateUtils'
import { TypeAdherent } from '../../../../../constant/TypeAdherent'

type BankAccountChequeCellProps = {
	ribInfo: any
	ribs: any[]
	individuList: any[]
	assurePrincipal: any
	conjoint: boolean
}

const BankAccountChequeCell: React.FC<BankAccountChequeCellProps> = (
	{
		ribInfo,
		ribs,
		individuList,
		assurePrincipal,
		conjoint
	}
) => {
	const intl = useIntl()

	const [openDrawer, setOpenDrawer] = useState<boolean>(false)
	const [openPopin, setOpenPopin] = useState<boolean>(false)

	const titleMessage = 'personalInfo.bankInfo.refund.title'
	const noTitulaireTitleMessage = 'personalInfo.bankInfo.refund.titleNoTitulaire'
	const isAssurePrincipal = ribInfo.numindiv !== assurePrincipal.numIndividu
	const subtitleMessage = 'personalInfo.bankInfo.contribution.subtitle'

	const titulaireList = useMemo(() => ribs.filter((rib: any) => rib.bban).map((rib: any) => rib.titulaire), [ribs])
	const titulaireCheque = useMemo(() => ribs.filter((rib: any) => !rib.bban).map((rib: any) => rib.titulaire), [ribs])
	const titulairesRibDispo = useMemo(() => individuList
		.filter((benef) => {
			return !titulaireList.find((titulaire: any) => titulaire[1].numIndividu === benef[1].numIndividu)
		})
		.filter(beneficiaire => estMajeurFinAnnee(beneficiaire[1].dateNaissance)), [titulaireList, individuList])
	const optionsTitulairesRib = useMemo(() => {
		if (isAssurePrincipal) {
			return titulaireList
		}
		return individuList.filter(benef => benef[1].typAdr !== TypeAdherent.ASSURE_PRINCIPAL && estMajeurFinAnnee(benef[1].dateNaissance))
	}, [titulairesRibDispo, titulaireList, isAssurePrincipal, individuList])

	const { libNature } = ribInfo

	const titulaire = useMemo(() => ribInfo?.intitule || '', [ribInfo])

	const displayedTitleMessage = useMemo(() => titulaire ? titleMessage : noTitulaireTitleMessage, [titulaire, titleMessage])

	return (
		<>
			<ListItem disablePadding sx={{ borderTop: '1px solid #dedede' }}>
				<ListItemButton onClick={() => setOpenDrawer(true)} sx={{ paddingRight: 0, paddingLeft: 0 }}>
					<ListItemText
						primary={intl.formatMessage({ id: displayedTitleMessage }, { titulaire })}
						primaryTypographyProps={{ variant: 'h4' }}
						secondary={intl.formatMessage({ id: subtitleMessage }, {
							type: libNature?.toUpperCase()
						})}
						secondaryTypographyProps={{ variant: 'subtitle1' }}
					/>
					<ListItemIcon style={{ justifyContent: 'flex-end' }}>
						<ChevronRight />
					</ListItemIcon>
				</ListItemButton>
			</ListItem>
			<RightDrawer openModal={openDrawer} setOpenModal={setOpenDrawer} title={intl.formatMessage({ id: 'personalInfo.bankInfo.title' })}>
				<Stack direction="column">
					<Typography variant="h4">
						{intl.formatMessage({ id: noTitulaireTitleMessage })}
					</Typography>
					<Typography variant="subtitle1">
						{intl.formatMessage({ id: 'personalInfo.bankInfo.contribution.subtitle' }, {
							type: libNature?.toUpperCase()
						})}
					</Typography>
				</Stack>

				<InfoField
					label={intl.formatMessage({ id: 'personalInfo.bankInfo.labels.ordre' })}
					value={ribInfo?.intitule || ''}
				/>

				<Box display="flex" flex={1}>
					<ButtonLink
						variant="contained"
						startIcon={<Icon size="20px" path={mdiFastForward} />}
						onClick={() => setOpenPopin(true)}
					>
						<FormattedMessage id="personalInfo.bankInfo.buttons.virement" />
					</ButtonLink>
				</Box>
			</RightDrawer>
			<BankActionFormPopin
				open={openPopin}
				setOpen={setOpenPopin}
				title={intl.formatMessage({ id: 'personalInfo.bankInfo.input.title.virement' })}
				ribInfo={ribInfo}
				titulaireCheque={titulaireCheque}
				formType="to_virement"
				assurePrincipal={assurePrincipal}
				individuList={individuList}
				optionsTitulairesRib={optionsTitulairesRib}
				conjoint={conjoint}
			/>
		</>
	)
}

export default BankAccountChequeCell
